export default __webpack_public_path__ + "static/media/ic_no_natifications.ed5abff7.svg";